<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-UserSnao"
                     *ngIf="!fieldsets.UserSnao.hidden && !fieldsets.UserSnao.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.UserSnao.collapsible }">
                    <div *ngIf="!fieldsets.UserSnao.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.UserSnao.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.UserSnao.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.UserSnao.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.UserSnao.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.UserSnao.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.UserSnao.expanded"
                         class="fieldsetsGroup">
                    </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.UserSnao.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>